export default "__VITE_ASSET__CeASSvtH__"